import { LETTER_TO_DTMF_MAP } from '@/constants/dtmf';

/**
 * Convert a string to DTMF codes
 * Letters are converted to their DTMF equivalents
 * Numbers and special characters (* #) are kept as-is
 *
 * @param input - The input string to convert
 * @returns The DTMF string
 */
export function convertToDTMF(input: string): string {
  let result = '';

  for (const char of input) {
    if (LETTER_TO_DTMF_MAP[char]) {
      // Letter - convert to DTMF
      result += LETTER_TO_DTMF_MAP[char];
    } else if (/[0-9*#]/.test(char)) {
      // Number or special DTMF character - keep as-is
      result += char;
    }
    // Ignore any other characters (spaces, etc.)
  }

  return result;
}

/**
 * Extract only the actual DTMF tones to send (single characters)
 * This is what gets sent to the IVR system
 *
 * @param dtmfString - The full DTMF string with letter codes
 * @returns String of single DTMF tones to send
 */
export function extractDTMFTones(dtmfString: string): string {
  // For sending to IVR, we need to send each character of the DTMF string
  // e.g., "*91" becomes three tones: "*", "9", "1"
  return dtmfString;
}
